<template>
  <div>
    <div class="form-group">
      <label class="is-required">Provinsi</label>
      <select v-model="selectedProvinceId" :name="provinceName" id="province_id" class="form-control" placeholder="Pilih provinsi" required>
        <option hidden value="">Pilih provinsi</option>
        <option v-for="(province, index) in provinces" :key="index" :value="province.id">{{ province.name }}</option>
      </select>
    </div>

    <div class="form-group">
      <label class="is-required">Kota / Kabupaten</label>
      <select v-model="selectedRegencyId" :name="regencyName" id="regency_id" class="form-control" placeholder="Pilih kota / kabupaten" required>
        <option hidden value="">Pilih kota / kabupaten</option>
        <option v-for="(regency, index) in shippingProvinceRegencies" :key="index" :value="regency.id">{{ regency.name }}</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    provinces: {
      type: Array,
      default: []
    },
    regencies: {
      type: Array,
      default: []
    },
    selectedProvince: {
      type: Number
    },
    selectedRegency: {
      type: Number
    },
    provinceName: {
      type: String,
      default: () => 'province_id'
    },
    regencyName: {
      type: String,
      default: () => 'regency_id'
    }
  },
  data() {
    return {
      errors: null,
      selectedRegencyId: "",
      selectedProvinceId: ""
    }
  },
  computed: {
    shippingProvinceRegencies() {
      return this.regencies.filter(r => r.province_id === this.selectedProvinceId)
    }
  },
  mounted() {
    this.selectedRegencyId = this.selectedRegency
    this.selectedProvinceId = this.selectedProvince
  }
}
</script>